angular.module('homebot.directives')

.directive('mortgageFooterSimple', ['$rootScope', function($rootScope){
  return {
    restrict: 'A',
    controllerAs: 'mortgageFooterCtrl',
    bindToController: {
      agent: '='
    },
    scope: {},
    transclude: true,
    templateUrl: '/homes/templates/partials/mortgage-footer-simple.html',
    controller: function(){
      const ctrl = this;

      ctrl.photo = _.get(this, 'agent.sponsor.photo', this.agent.photo);
    }
  }
}]);
